// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle span {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px; }\n", "",{"version":3,"sources":["webpack://./src/components/atoms/inputToggle/toggle.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA","sourcesContent":[".toggle {\n  span {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
